import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getSOCCodes = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/lookups/soc-codes");
    const socCodes = res.data.data;

    if (socCodes) {
      localStorage.setItem("socCodes", JSON.stringify(socCodes));
    }

    dispatch({
      type: CommonActionTypes.GET_ALL_SOC_CODES_DATA,
      payload: socCodes,
    });

    return socCodes;
  } catch (err) {
    const message =
      err.response?.data?.message || err.message || err.toString();

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return [];
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
